import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';


const config = {
    "startMenu": [
        {
            "className": "bg-gray text-white rounded p-1 text-center ff-1 animate__animated animate__slideInDown ",
            "icon": "",
            "text": "Lebenshilfe Rinteln",
            "props": [
                {
                    "text": "Aktuelles",
                    "path": "/aktuelles"
                },
                {
                    "text": "Verein",
                    "path": "verein"
                },
                {
                    "text": "Stallpiraten",
                    "path": "stallpiraten"
                },
                {
                    "text": "Werkfeuerwehr",
                    "path": "werkfeuerwehr"
                },
                {
                    "text": "British Military Hospital",
                    "path": "bmh"
                }
            ]
        },
        {
            "className": "bg-warning text-white rounded p-1 text-center ff-1 animate__animated animate__slideInUp ",
            "icon": "",
            "text": "Kinder & Jugend",
            "props": [
                {
                    "text": "Frühförderung",
                    "path": "/fruehforderung"
                },
                {
                    "text": "Integrative Kita am Waldkater",
                    "props": [
                        {
                            "text": "Krippe",
                            "path": "/krippe"
                        },
                        {
                            "text": "Kindergarten",
                            "path": "/kindergarten"
                        },
                        {
                            "text": "Integrative Kindergartengruppe",
                            "path": "/integrativekindergartengruppe"
                        }
                    ]
                },
                {
                    "text": "Heilpädagogischer Kindergarten am Waldkater",
                    "path": "/heilpedagogischekindergarden"
                },
                {
                    "text": "Schule am Waldkater",
                    "path": "/schuleamwaldkater"
                },
                {
                    "text": "ZARi – Zentrum für Autismus",
                    "path": "/zari"
                }
            ]
        },
        {
            "className": "bg-info text-white rounded p-1 text-center ff-1 animate__animated animate__slideInLeft ",
            "icon": "",
            "text": "Wohnen",
            "props": [
                {
                    "text": "Wohnen",
                    "path": "Wohnen"
                },
                {
                    "text": "Wohnbereiche",
                    "props": [
                        {
                            "text": "Alexandra",
                            "path": "/alexandra"
                        },
                        {
                            "text": "Antonia",
                            "path": "/antonia"
                        },
                        {
                            "text": "Katharina",
                            "path": "/katharina"
                        },
                        {
                            "text": "Victoria",
                            "path": "/victoria"
                        },
                        {
                            "text": "Wohntraining und Apartments",
                            "path": "/wohntraining"
                        }
                    ]
                },
                {
                    "text": "ABW (Assistenz beim Wohnen)",
                    "path": "EigeneWohnung"
                }
            ]
        },
        {
            "className": "bg-success text-white rounded p-1 text-center ff-1 animate__animated animate__slideInRight ",
            "icon": "",
            "text": "Senioren",
            "props": [
                {
                    "icon": "",
                    "text": "Pflegeheim am Waldkater",
                    "path": "/hausamwaldkater"
                },
                {
                    "icon": "",
                    "text": "Tagespflege am Waldkater",
                    "path": "/tagespflegeamwaldkater"
                }
            ]
        },
        {
            "className": "bg-danger text-white rounded p-1 text-center ff-1 animate__animated animate__slideInLeft ",
            "icon": "",
            "text": "Ambulante Dienste",
            "props": [
                {
                    "text": "Frühförderung",
                    "path": "/fruehforderung"
                },
                {
                    "text": "ABW (Assistenz beim Wohnen)",
                    "path": "/eigenewohnung"
                },
                {
                    "text": "Sozialpädagogische Familienhilfe (SPFH)",
                    "path": "/spfh"
                },
                {
                    "text": "ZARi – Zentrum für Autismus",
                    "path": "/zari"
                }
            ]
        },
        {
            "className": "bg-lila text-white rounded p-1 text-center ff-1 animate__animated animate__slideInRight ",
            "icon": "",
            "text": "Therapiezentrum",
            "path": "/therapiezentrum"
        },
        {
            "className": "bg-gray text-white rounded p-1 text-center ff-1 animate__animated animate__slideInLeft ",
            "icon": "",
            "text": "Verschiedenes",
            "props": [
                {
                    "text": "Datenschutz",
                    "path": "/datenschutz"
                },
                {
                    "text": "Impressum",
                    "path": "/impressum"
                },
                {
                    "text": "Stellenangebote",
                    "path": "/stellenangebote"
                }
            ]
        }
    ],
    "abteilungen": [
        {
            "name": "Allgemein",
            "mail": "verwaltung@lebenshilfe-rinteln.de"
        },
        {
            "name": "Frühförderung",
            "mail": "fruehfoerderung@lebenshilfe-rinteln.de"
        },
        {
            "name": "Heilpädagogischer Kindergarten",
            "mail": "hpkg@lebenshilfe-rinteln.de"
        },
        {
            "name": "Integrative Kindertagesstätte",
            "mail": "hpkg@lebenshilfe-rinteln.de"
        },
        {
            "name": "Schule am Waldkater",
            "mail": "schuleamwaldkater@lebenshilfe-rinteln.de"
        },
        {
            "name": "Wohnbereiche",
            "mail": "m.reinking@lebenshilfe-rinteln.de"
        },
        {
            "name": "ABW",
            "mail": "t.meier@lebenshilfe-rinteln.de"
        },
        {
            "name": "Haus am Waldkater",
            "mail": "hwk@lebenshilfe-rinteln.de"
        },
        {
            "name": "Verein",
            "mail": "verein@lebenshilfe-rinteln.de"
        },
        {
            "name": "Werkfeuerwehr",
            "mail": "werkbrandmeister@lebenshilfe-rinteln.de"
        },
        {
            "name": "SPFH",
            "mail": "spfh@lebenshilfe-rinteln.de"
        }
    ]
}



ReactDOM.render(<App config={config} />, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
